import Entity from 'lib/Entity';

export default class FaqSection extends Entity {
  getName() {
    return this.get('name');
  }
}
